import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { PessoaJuridica } from '../shared/model';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PessoaJuridicaService {

  private readonly service = '/sepin-backend/rest/proxy/pessoa-juridica';
  private readonly serviceEntidade = '/sepin-backend/rest/entidades';

  constructor(private readonly http: McticHttpClient) {
  }

  consultarPorCnpj(cnpj: string) {
    return this.http.get<PessoaJuridica>(`${this.service}/cnpj/${cnpj}`);
  }

  consultarEntidadePorCnpj(cnpj: string) {
    return this.http.get<PessoaJuridica>(`${this.serviceEntidade}/consultar-pj/cnpj/${cnpj}`);
  }

  consultarPorId(idPessoaJuridica: number) {
    return this.http.get<PessoaJuridica[]>(`${this.service}/basico/${idPessoaJuridica}`);
  }
}
